export const DEFAULT_SLIDER_PROPS = {
  min: 0,
  max: 100,
  step: 1,
  defaultValue: 0, 
};